import { render, staticRenderFns } from "./TypeThree.vue?vue&type=template&id=0d7f99b6&scoped=true"
import script from "./TypeThree.vue?vue&type=script&lang=js"
export * from "./TypeThree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7f99b6",
  null
  
)

export default component.exports